import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IQuestionAnswerAPI,
  questionTypes,
} from "../components/questionnaires/questionnaire-builder/QuestionnarieBuilderOptions";
import { questionnariePatientAnswer } from "../services/api/QuestionnarieApi";

export const larcEligibilitySlice = createSlice({
  name: "larc_eligibility",
  initialState: {},
  reducers: {
    setLARCEligiblity: (state: any, action: PayloadAction<object>) => {
      state.data = action.payload;
      if (state.data.status !== "completed" && state.data.id) {
        const answer: any = [];
        state?.data?.QuestionSetIds?.questions.map((question: any) => {
          if (question.type === questionTypes.multiplechoice) {
            question.userAnswer.map((ans: any) => {
              answer.push({
                answer: ans?.answer,
                optionId: ans?.optionId,
                questionId: question.id,
              });
            });
          } else {
            answer.push({
              answer: question.userAnswer?.[0]?.answer,
              optionId: question.userAnswer?.[0]?.optionId,
              questionId: question.id,
            });
          }
        });
        const answerPayload: IQuestionAnswerAPI = {
          shareId: state.data.id,
          questionSetId: state.data.questionSetId,
          status: "draft",
          answers: answer,
        };
        questionnariePatientAnswer(answerPayload);
      }
    },
    submitLARCEligiblity: (state: any, action: PayloadAction<object>) => {
      state.data = action.payload;
      const answer: any = [];
      state?.data?.QuestionSetIds?.questions.map((question: any) => {
        if (question.type === questionTypes.multiplechoice) {
          question.userAnswer.map((ans: any) => {
            answer.push({
              answer: ans?.answer,
              optionId: ans?.optionId,
              questionId: question.id,
            });
          });
        } else {
          answer.push({
            answer: question.userAnswer?.[0]?.answer,
            optionId: question.userAnswer?.[0]?.optionId,
            questionId: question.id,
          });
        }
      });
      const answerPayload: IQuestionAnswerAPI = {
        shareId: state.data.id,
        questionSetId: state.data.questionSetId,
        status: state.data.status === "hold" ? "hold" : "completed",
        answers: answer,
      };
      questionnariePatientAnswer(answerPayload);
    },
  },
});

export const { setLARCEligiblity, submitLARCEligiblity } =
  larcEligibilitySlice.actions;

export default larcEligibilitySlice.reducer;
